import { render, staticRenderFns } from "./CustomerPurchaseOrderList.vue?vue&type=template&id=199f4ba8&"
import script from "./CustomerPurchaseOrderList.vue?vue&type=script&lang=js&"
export * from "./CustomerPurchaseOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports